import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    isGetterRouter: false,// 是否添加路由
    isCollapse: false,// 是否折叠菜单
    userInfo: {},// 用户信息
    // 企业认证审核角标
    enterpriseState: {
      hidden: true,
      total: 0
    },
    // 手动退款角标
    refundState: {
      hidden: true,
      total: 0
    },
    // 售车信息角标
    sellState: {
      hidden: true,
      total: 0
    },
    // 求购车源信息角标
    buyState: {
      hidden: true,
      total: 0
    },
    // 协助下架信息角标
    assistState: {
      hidden: true,
      total: 0
    },
    tagViews: [],
    tagViewsCatch: [],
  },
  getters: {
    // 获取tags
    getVisitedViews(state) {
      return state.tagViews
    },
    // 获取tags
    getVisitedViewCatchs(state) {
      return state.tagViewsCatch;
    },
  },
  mutations: {
    changeGetterRouter(state, value) {
      state.isGetterRouter = value;
    },
    // 折叠菜单
    changeCollapse(state) {
      state.isCollapse = !state.isCollapse;
    },
    // 用户信息赋值
    changeUserInfo(state, value) {
      state.userInfo = {
        ...state.userInfo,
        ...value,
      };
    },
    // 清空用户信息
    clearUserInfo(state) {
      state.userInfo = {};
    },
    // 企业认证审核
    changeentErpriseState(state, total) {
      state.enterpriseState = {
        hidden: total == 0 ? true : false,
        total: total
      };
    },
    // 修改手动退款状态
    changeRefundState(state, total) {
      state.refundState = {
        hidden: total == 0 ? true : false,
        total: total
      };
    },
    // 修改售车信息状态
    changeSellState(state, total) {
      state.sellState = {
        hidden: total == 0 ? true : false,
        total: total
      };
    },
    // 修改求购车源信息状态
    changeBuyState(state, total) {
      state.buyState = {
        hidden: total == 0 ? true : false,
        total: total
      };
    },
    // 修改求购车源信息状态
    changeAssistState(state, total) {
      state.assistState = {
        hidden: total == 0 ? true : false,
        total: total
      };
    },
    // 新增tags
    addTags(state, view) {
      const tagViews = JSON.parse(JSON.stringify(state.tagViews));
      if (tagViews.some((v) => v.path === view.path)) return;
      if (view.meta?.noTagsView) return;
      state.tagViews.push(
        Object.assign({}, view, {
          title: view.meta?.title || 'no-name'
        })
      )
    },
    removeTag(state, view) {
      const tagViews = JSON.parse(JSON.stringify(state.tagViews));
      for (let i = 0; i < tagViews.length; i++) {
        const v = tagViews[i];
        if (v.path === view.path) {
          tagViews.splice(i, 1)
          break
        }
      }
      state.tagViews = tagViews;
    },
    addTagCatch(state, view) {
      const tagViewsCatch = JSON.parse(JSON.stringify(state.tagViewsCatch));
      if (tagViewsCatch.some((v) => v.path === view.path)) return;
      if (view.meta?.noTagsView) return;
      state.tagViewsCatch.push(view.name)
    },
    removeTagCatch(state, view) {
      let tagViewsCatch = JSON.parse(JSON.stringify(state.tagViewsCatch));
      state.tagViewsCatch = tagViewsCatch.filter((name) => view.name != name);
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({
    paths: ["isCollapse", "userInfo"]
  })],
})
